// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wVO-","name":"styles_name__sSv4J","phone":"styles_phone__1-AHA"};